/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Affiliate_TermsInputs */

const en_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate Terms`)
};

const zh_hans1_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广计划条款`)
};

const pt_br2_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de Afiliados`)
};

const es_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de afiliados`)
};

const fr_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions d’affiliation`)
};

const de_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerbedingungen`)
};

const ru_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия партнёрской программы`)
};

const it_footer_affiliate_terms = /** @type {(inputs: Footer_Affiliate_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini per gli affiliati`)
};

/**
* | output |
* | --- |
* | "Affiliate Terms" |
*
* @param {Footer_Affiliate_TermsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_affiliate_terms = /** @type {((inputs?: Footer_Affiliate_TermsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Affiliate_TermsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_affiliate_terms(inputs)
	if (locale === "pt-BR") return pt_br2_footer_affiliate_terms(inputs)
	if (locale === "es") return es_footer_affiliate_terms(inputs)
	if (locale === "fr") return fr_footer_affiliate_terms(inputs)
	if (locale === "de") return de_footer_affiliate_terms(inputs)
	if (locale === "ru") return ru_footer_affiliate_terms(inputs)
	if (locale === "it") return it_footer_affiliate_terms(inputs)
	return en_footer_affiliate_terms(inputs)
});